import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../core/auth-service.component';
import { MenuItemService } from '../shared/sidebar/services/menu-itemservices';
import { SpinnerService } from '../core/loader/spinner.service';
import {UserService} from '../commonservices/user.service';
import { CustomCookieService } from '../commonservices/custom-cookie.service';
import { EnvService } from '../core/env.service';

@Component({
  selector: 'app-application',
  styleUrls: ['./application.scss'],
  templateUrl: './applications.component.html'
})

export class Applications implements OnInit {
  public sidebarnavItems: any[];

  constructor(private _authService: AuthService,
              private _router: Router, private _menuitem : MenuItemService,
              public _spinnerService: SpinnerService, private _userService: UserService,
              private _cookieService: CustomCookieService,private _env: EnvService) { }

  ngOnInit() { 

    //we still need to check if cookie __ctgf is existing and not expire
    this._userService.CheckCookie().subscribe(data =>{
        if(data.IsValidCookie == false){
            this._cookieService.removeAllCookiesExceptOidc();
            this._authService.logout();
        }else{
          window.location.href = this._env.rateTrakApplicationPage;
        }
     })
  }

  rightClick(app: string, path: string){
  }
  
  public redirect(app,path) {
  }

  logoff() {
  }
}